import { string, object } from 'yup';

const validationSchema = object().shape({
  contactReason: string().required('A reason is required'),
  contactMessage: string().required('A message is required'),
});
export default validationSchema;
